export default {
  locale: 'zh-cn',
  Pagination: {
    items_per_page: 'អត្ថបទ/ទំព័រ',
    jump_to: 'លោតComment',
    jump_to_confirm: 'កំណត់@ info: whatsthis',
    page: 'ទំព័រ',
    prev_page: 'ទំព័រ មុន',
    next_page: 'ទំព័រ បន្ទាប់',
    prev_5: '៥ ទំព័រ ទៅ មុន',
    next_5: '៥ ទំព័រ ក្រោយ ។',
    prev_3: '៣ ទំព័រ ទៅ មុន',
    next_3: '៣ ទំព័រ ក្រោយ ។',
    page_size: 'លេខ ទំព័រ',
  },
  DatePicker: {
    lang: {
      placeholder: 'សូម ជ្រើស កាលបរិច្ឆេទ',
      yearPlaceholder: 'សូម ជ្រើស ឆ្នាំ មួយ@ info: whatsthis',
      quarterPlaceholder: 'សូម ជ្រើស ចេញ',
      monthPlaceholder: 'សូម ជ្រើស ខែ ។',
      weekPlaceholder: 'សូម ជ្រើស សប្ដាហ៍ ។',
      rangePlaceholder: ['កាលបរិច្ឆេទ ចាប់ផ្ដើម', 'កាលបរិច្ឆេទ បញ្ចប់'],
      rangeYearPlaceholder: ['ឆ្នាំ ចាប់ផ្ដើម', 'ឆ្នាំ បញ្ចប់'],
      rangeMonthPlaceholder: ['ខែ ចាប់ផ្ដើម', 'ខែ បញ្ចប់'],
      rangeWeekPlaceholder: ['ចាប់ផ្ដើម សប្ដាហ៍', 'ចុង សប្ដាហ៍'],
      locale: 'zh_CN',
      today: 'ថ្ងៃ នេះ@ item: inlistbox',
      now: 'នៅ ពេល ម៉ោង ៖',
      backToToday: 'ត្រឡប់ ថ្ងៃ នេះ ។',
      ok: 'កំណត់@ info: whatsthis',
      timeSelect: 'ជ្រើស ពេលវេលា',
      dateSelect: 'ជ្រើស កាលបរិច្ឆេទ',
      weekSelect: 'ជ្រើស សប្ដាហ៍',
      clear: 'ជម្រះ',
      month: 'ខែ',
      year: 'ឆ្នាំComment',
      previousMonth: 'ខែ ចុងក្រោយ (កូនសោ ត្រឡប់ ទំព័រ)',
      nextMonth: 'ខែ បន្ទាប់ (ត្រឡប់ ទំព័រ ចុះក្រោម គ្រាប់ ចុច)',
      monthSelect: 'ជ្រើស ខែ',
      yearSelect: 'ជ្រើស ឆ្នាំComment',
      decadeSelect: 'ជ្រើស ប្រព័ន្ធ',
      yearFormat: 'ឆ្នាំ YYYY',
      dayFormat: 'D- ថ្ងៃComment',
      dateFormat: 'ថ្ងៃ YYYY ឆ្នាំ M ខែ D ថ្ងៃ@ info: whatsthis',
      dateTimeFormat: 'YYYY ឆ្នាំ M ថ្ងៃ D ថ្ងៃ HH ពេលវេលា mm នាទី ss វិនាទី',
      previousYear: 'ឆ្នាំ មុន (គ្រាប់ចុច បញ្ជា បន្ថែម គ្រាប់ចុច ព្រួញ ខាង ឆ្វេង)',
      nextYear: 'ឆ្នាំ បន្ទាប់ (គ្រាប់ចុច គ្រាប់ចុច ព្រួញ ខាង ស្ដាំ)',
      previousDecade: 'លុប មុន',
      nextDecade: 'ពិសោធ បន្ទាប់',
      previousCentury: 'សៀវភៅ មុន',
      nextCentury: 'សៀវភៅ បន្ទាប់',
    },
    timePickerLocale: {
      placeholder: 'សូម ជ្រើស ពេលវេលា',
      rangePlaceholder: ['ពេលវេលា ចាប់ផ្ដើម', 'ពេលវេលា បញ្ចប់'],
    },
  },
  TimePicker: {
    placeholder: 'សូម ជ្រើស ពេលវេលា',
    rangePlaceholder: ['ពេលវេលា ចាប់ផ្ដើម', 'ពេលវេលា បញ្ចប់'],
  },
  Calendar: {
    lang: {
      placeholder: 'សូម ជ្រើស កាលបរិច្ឆេទ',
      yearPlaceholder: 'សូម ជ្រើស ឆ្នាំ មួយ@ info: whatsthis',
      quarterPlaceholder: 'សូម ជ្រើស ចេញ',
      monthPlaceholder: 'សូម ជ្រើស ខែ ។',
      weekPlaceholder: 'សូម ជ្រើស សប្ដាហ៍ ។',
      rangePlaceholder: ['កាលបរិច្ឆេទ ចាប់ផ្ដើម', 'កាលបរិច្ឆេទ បញ្ចប់'],
      rangeYearPlaceholder: ['ឆ្នាំ ចាប់ផ្ដើម', 'ឆ្នាំ បញ្ចប់'],
      rangeMonthPlaceholder: ['ខែ ចាប់ផ្ដើម', 'ខែ បញ្ចប់'],
      rangeWeekPlaceholder: ['ចាប់ផ្ដើម សប្ដាហ៍', 'ចុង សប្ដាហ៍'],
      locale: 'zh_CN',
      today: 'ថ្ងៃ នេះ@ item: inlistbox',
      now: 'នៅ ពេល ម៉ោង ៖',
      backToToday: 'ត្រឡប់ ថ្ងៃ នេះ ។',
      ok: 'កំណត់@ info: whatsthis',
      timeSelect: 'ជ្រើស ពេលវេលា',
      dateSelect: 'ជ្រើស កាលបរិច្ឆេទ',
      weekSelect: 'ជ្រើស សប្ដាហ៍',
      clear: 'ជម្រះ',
      month: 'ខែ',
      year: 'ឆ្នាំComment',
      previousMonth: 'ខែ ចុងក្រោយ (កូនសោ ត្រឡប់ ទំព័រ)',
      nextMonth: 'ខែ បន្ទាប់ (ត្រឡប់ ទំព័រ ចុះក្រោម គ្រាប់ ចុច)',
      monthSelect: 'ជ្រើស ខែ',
      yearSelect: 'ជ្រើស ឆ្នាំComment',
      decadeSelect: 'ជ្រើស ប្រព័ន្ធ',
      yearFormat: 'ឆ្នាំ YYYY',
      dayFormat: 'D- ថ្ងៃComment',
      dateFormat: 'ថ្ងៃ YYYY ឆ្នាំ M ខែ D ថ្ងៃ@ info: whatsthis',
      dateTimeFormat: 'YYYY ឆ្នាំ M ថ្ងៃ D ថ្ងៃ HH ពេលវេលា mm នាទី ss វិនាទី',
      previousYear: 'ឆ្នាំ មុន (គ្រាប់ចុច បញ្ជា បន្ថែម គ្រាប់ចុច ព្រួញ ខាង ឆ្វេង)',
      nextYear: 'ឆ្នាំ បន្ទាប់ (គ្រាប់ចុច គ្រាប់ចុច ព្រួញ ខាង ស្ដាំ)',
      previousDecade: 'លុប មុន',
      nextDecade: 'ពិសោធ បន្ទាប់',
      previousCentury: 'សៀវភៅ មុន',
      nextCentury: 'សៀវភៅ បន្ទាប់',
    },
    timePickerLocale: {
      placeholder: 'សូម ជ្រើស ពេលវេលា',
      rangePlaceholder: ['ពេលវេលា ចាប់ផ្ដើម', 'ពេលវេលា បញ្ចប់'],
    },
  },
  global: {
    placeholder: 'សូម ជ្រើស',
  },
  Table: {
    filterTitle: 'តម្រង',
    filterConfirm: 'កំណត់@ info: whatsthis',
    filterReset: 'កំណត់ ឡើង វិញ',
    filterEmptyText: 'គ្មាន ធាតុ តម្រង',
    selectAll: 'ជ្រើស ទំព័រ ទាំងអស់',
    selectInvert: 'ទំព័រ ជ្រើស បញ្ច្រាស',
    selectNone: 'សម្អាត ទាំងអស់',
    selectionAll: 'ជ្រើស ទាំងអស់',
    sortTitle: 'តម្រង',
    expand: 'ពង្រីក ជួរដេក',
    collapse: 'បិទ ជួរដេក',
    triggerDesc: 'ចុច កំពុង បន្ទាប់',
    triggerAsc: 'ចុច កំពុង កើន',
    cancelSort: 'មិន តម្លៃ',
  },
  Modal: {
    okText: 'កំណត់@ info: whatsthis',
    cancelText: 'បោះបង់',
    justOkText: 'ខ្ញុំ ដឹង ។',
  },
  Popconfirm: {
    cancelText: 'បោះបង់',
    okText: 'កំណត់@ info: whatsthis',
  },
  Transfer: {
    searchPlaceholder: 'សូម បញ្ចូល មាតិកា ស្វែងរក',
    itemUnit: 'ធាតុ',
    itemsUnit: 'ធាតុ',
    remove: 'លុប',
    selectCurrent: 'ជ្រើស ទំព័រ ទាំងអស់',
    removeCurrent: 'លុប ទំព័រ បច្ចុប្បន្ន',
    selectAll: 'ជ្រើស ទាំងអស់',
    removeAll: 'លុប ទាំងអស់',
    selectInvert: 'ទំព័រ ជ្រើស បញ្ច្រាស',
  },
  Upload: {
    uploading: 'ការ ផ្ទុក ឡើង ឯកសារ',
    removeFile: 'លុប ឯកសារ',
    uploadError: 'កំហុស ផ្ទុក ឡើង',
    previewFile: 'មើល ឯកសារ ជាមុន',
    downloadFile: 'ទាញយក ឯកសារ',
  },
  Empty: {
    description: 'គ្មាន ទិន្នន័យ',
  },
  Icon: {
    icon: 'រូបតំណាង',
  },
  Text: {
    edit: 'កែសម្រួល',
    copy: 'ចម្លង',
    copied: 'ចម្លង ជោគជ័យ',
    expand: 'ពង្រីក',
  },
  PageHeader: {
    back: 'ត្រឡប់ វិញ',
  },
  Form: {
    optional: '(ជម្រើស)',
    defaultValidateMessages: {
      default: 'កំហុស ការ សុពលភាព វាល ${label}',
      required: 'សូម បញ្ចូល ${label}',
      enum: '${Label} ត្រូវ តែ ជា មួយ [${enum}]',
      whitespace: '${Label} មិន អាច ជា តួអក្សរ  Null',
      date: {
        format: '${Label} ទ្រង់ទ្រាយ កាលបរិច្ឆេទ មិន ត្រឹមត្រូវ',
        parse: '${Label} មិន អាច ត្រូវ បាន បម្លែង ទៅ កាលបរិច្ឆេទ',
        invalid: '${Label} គឺ ជា កាលបរិច្ឆេទ មិន ត្រឹមត្រូវ',
      },
      types: {
        string: '${Label} មិនមែន ជា ${ ប្រភេទ} ត្រឹមត្រូវ',
        method: '${Label} មិនមែន ជា ${ ប្រភេទ} ត្រឹមត្រូវ',
        array: '${Label} មិនមែន ជា ${ ប្រភេទ} ត្រឹមត្រូវ',
        object: '${Label} មិនមែន ជា ${ ប្រភេទ} ត្រឹមត្រូវ',
        number: '${Label} មិនមែន ជា ${ ប្រភេទ} ត្រឹមត្រូវ',
        date: '${Label} មិនមែន ជា ${ ប្រភេទ} ត្រឹមត្រូវ',
        boolean: '${Label} មិនមែន ជា ${ ប្រភេទ} ត្រឹមត្រូវ',
        integer: '${Label} មិនមែន ជា ${ ប្រភេទ} ត្រឹមត្រូវ',
        float: '${Label} មិនមែន ជា ${ ប្រភេទ} ត្រឹមត្រូវ',
        regexp: '${Label} មិនមែន ជា ${ ប្រភេទ} ត្រឹមត្រូវ',
        email: '${Label} មិនមែន ជា ${ ប្រភេទ} ត្រឹមត្រូវ',
        url: '${Label} មិនមែន ជា ${ ប្រភេទ} ត្រឹមត្រូវ',
        hex: '${Label} មិនមែន ជា ${ ប្រភេទ} ត្រឹមត្រូវ',
      },
      string: {
        len: '${Label} ត្រូវ តែ តួអក្សរ ${len}',
        min: '${Label} តួអក្សរ អប្បបរមា ${mín}',
        max: '${Label} ទៅ កាន់ តួអក្សរ ${Max}',
        range: '${Label} ត្រូវ តែ តួអក្សរ ${min}-${max}',
      },
      number: {
        len: '${Label} ត្រូវ តែ ស្មើ ${len}',
        min: 'តម្លៃ អប្បបរមា នៃ ${label} គឺ ${mín}',
        max: 'តម្លៃ អតិបរមា នៃ ${label} គឺ ${Max}',
        range: '${Label} ត្រូវ តែ រវាង ${min}-${max}',
      },
      array: {
        len: 'ត្រូវ តែ ជា ${len} ${label}',
        min: 'អប្បបរមា ${មីន} ${label}',
        max: 'ទៅ ${Max} ${label}',
        range: '${Label} ត្រូវ តែ រវាង ${mín} និង ${max}',
      },
      pattern: {
        mismatch: '${Label} មិន ផ្គូផ្គង លំនាំ ${pattern}',
      },
    },
  },
  Image: {
    preview: 'មើល ជាមុន',
  },
};
